import { StateList } from '../pages/StateManager/StateList'

var urls = {
  dashboard: '/api/admin-service/dashboard',

  forgotPassword: '/api/admin-service/forget/password',

  resetAdminPassword: '/api/admin-service/reset/password',
  adminLogin: '/api/admin-service/auth/login',
  profileDetail: '/api/admin-service/auth/get-profile-details',
  updateProfile: '/api/admin-service/update-profile',
  updatePassword: '/api/admin-service/update-password',
  addRole: '/api/admin-service/role/add-role',
  roleList: '/api/admin-service/role/role-list',
  changeRoleStatus: '/api/admin-service/role/change/status',
  roleKeyValuePair: '/api/admin-service/role/role-key-value',
  rolePermissionUpdate: '/api/admin-service/set-permission',
  fetchPermission: '/api/admin-service/role-permission-details',

  watchTimeSubscriptionGetAllProduct: '/api/admin-service/watch-time-subscription/get-all-product',

  packagesList: '/api/admin-service/packages/list',
  changePackageStatus: '/api/admin-service/packages/change/status',
  addPackage: '/api/admin-service/packages/create',

  videoList: '/api/admin-service/video/list',
  activeInActiveVideo: '/api/admin-service/video/active-inactive',
  rewardOnVideo: '/api/admin-service/video/give-reward',

  subAdminByRole: '/api/admin-service/subadmin/key-value-by-role',
  subAdminList: '/api/admin-service/subadmin/get/all/paged',
  subAdminAdd: '/api/admin-service/subadmin/create',
  subAdminChangeStatus: '/api/admin-service/subadmin/status',
  subAdminLogDetails: '/api/admin-service/subadmin/log-details',
  subAdminDelete: '/api/admin-service/subadmin/delete/by/id/',

  addFilter: '/api/admin-service/filter/add-filter',
  filterList: '/api/admin-service/filter/filter-list',
  changeFilterStatus: '/api/admin-service/filter/change/status',
  deleteFilter: '/api/admin-service/filter/delete/by/id',
  addNotification: '/api/admin-service/add/notification',
  notificationList: '/api/admin-service/notification-list',
  serviceCategories: '/api/admin-service/service/category-list',


  paymentGatewayList: '/api/admin-service/payment-gateway/list',
  paymentGatewayKeyValuePair: '/api/admin-service/payment-gateway/key-value-pair',

  addEffect: '/api/admin-service/effects/add',
  effectList: '/api/admin-service/effects/effect-list',
  changeEffectStatus: '/api/admin-service/effects/change/status',
  getEffect: '/api/admin-service/effects/get/by',
  deleteEffect: '/api/admin-service/effects/delete/by/id',

  addFontStyle: '/api/admin-service/font-style/add',
  fontStyleList: '/api/admin-service/font-style/list',
  changeFontStyleStatus: '/api/admin-service/font-style/change/status',
  getFontStyle: '/api/admin-service/font-style/get/by',
  deleteFontStyle: '/api/admin-service/font-style/delete/by',

  addSound: '/api/admin-service/sounds/add',
  soundList: '/api/admin-service/sounds/sound-list',
  changeSoundStatus: '/api/admin-service/sounds/change/status',
  getSound: '/api/admin-service/sounds/get/by',
  deleteSound: '/api/admin-service/sounds/delete/by/id',

  reportAbuseList: '/api/admin-service/report-abuse/list',
  abuseReportList: '/api/admin-service/report-abuse/reporters-list',

  activeInActiveReport: '/api/admin-service/report-abuse/active-inactive',

  userList: '/api/admin-service/users/user-list',
  userDetails: '/api/admin-service/users/user-by-id',
  userRecentTop3Videos: '/api/admin-service/video/recent-user-videos',
  userActiveInActive: '/api/admin-service/users/change/status',
  userCelebrityStatusChange: '/api/admin-service/users/celebrity/status',

  addWidget: '/api/admin-service/widget/add-widget',
  widgetList: '/api/admin-service/widget/widget-list',
  widgetKeyValuePair: '/api/admin-service/widget/key-value',
  changeWidgetStatus: '/api/admin-service/widget/change/status',
  getWidget: '/api/admin-service/widget/get/by',
  deleteWidget: '/api/admin-service/widget/delete/by/id',

  countryList: '/api/admin-service/country/country-list',
  addCountry: '/api/admin-service/country/add',
  importCountry: '/api/admin-service/country/import',
  changeCountryStatus: '/api/admin-service/country/change/status',
  countryCodeList: '/api/admin-service/country/country-code-list',

  createBotAccount: '/api/admin-service/bot-account/create',
  botAccountList: '/api/admin-service/bot-account/list',
  botAccountKeyValuePair: '/api/admin-service/bot-account/key-value-list',
  botVideoUpload: '/api/admin-service/bot-video/upload',
  botVideoList: '/api/admin-service/bot-video/list',

  routingHostConfigAddUpdate: '/api/admin-service/routing-host/add',
  getRoutingHostConfigDetails: '/api/admin-service/routing-host/get-details',

  stateList: '/api/admin-service/state/state-list',
  addState: '/api/admin-service/state/add',
  importState: '/api/admin-service/state/import',
  changeStateStatus: '/api/admin-service/state/change/status',
  stateCodeList: '/api/admin-service/state/state-key-value',
  stateCodeListByCountryId: '/api/admin-service/state/list-by-countryId',
  deleteState: '/api/admin-service/state/delete/by/id',

  taxTemplatesList: '/api/admin-service/tax-template/list',
  addTaxTemplate: '/api/admin-service/tax-template/add',

  getAllTypeOfMatrix: '/api/admin-service/globalAds/get-all-type',
  getAllTypeOfMatrixGlobalRate:
    '/api/admin-service/globalAds/get-config-global-matrix-rate',
  setMatrixGlobalWorldRate:
    '/api/admin-service/globalAds/set-config-global-matrix-rate',
  getConfigGLobalAdsMatrix:
    '/api/admin-service/globalAds/get-config-global-ads-matrix',
  configGlobalAdsMatrix:
    '/api/admin-service/globalAds/config-global-ads-matrix',
  adminUploadAds: '/api/admin-service/globalAds/admin-upload-ads',

  cityList: '/api/admin-service/city/city-list',
  addCity: '/api/admin-service/city/add',
  changeCityStatus: '/api/admin-service/city/change/status',
  cityCodeList: '/api/admin-service/city/state-key-value',
  cityCodeListByCountryId: '/api/admin-service/city/list-by-countryId',
  deleteCity: '/api/admin-service/city/delete/by/id',
  getCityCodeListByParent: '/api/admin-service/city/list-by-parentId',

  subscriptionPackageList: '/api/admin-service/watch-time-subscription/list',
  addSubScriptionPackage: '/api/admin-service/watch-time-subscription/add',

  districtList: '/api/admin-service/district/district-list',
  addDistrict: '/api/admin-service/district/add',
  importDistrict: '/api/admin-service/district/import',
  changeDistrictStatus: '/api/admin-service/district/change/status',
  districtCodeList: '/api/admin-service/district/district-key-value',
  deleteDistrict: '/api/admin-service/district/delete/by/id',
  getDistrictByStateId: '/api/admin-service/district/list-by-stateId',

  addTagInterest: '/api/admin-service/tags/add',
  tagInterestList: '/api/admin-service/tags/tag-list',
  tagInterestListKeyValuePair: '/api/admin-service/tags/interest-list',
  changeTagInterestStatus: '/api/admin-service/tags/change/status',

  changeMerchantStatus: '/api/admin-service/active-inactive-merchant',
  deleteBusinessMerchant: '/api/admin-service/delete-merchant',


  addBusinessCategory: '/api/admin-service/businessCategory/add-or-edit-category',
  businessCategoryList: '/api/admin-service/businessCategory/list',
  businessCategoryKeyValuePair: '/api/admin-service/businessCategory/interest-list',
  changeBusinessCategoryStatus: '/api/admin-service/businessCategory/change/status',
  getCategoyByIds: '/api/admin-service/businessCategory/get-Category-by-ids',


  addProductCategory: '/api/admin-service/product-category/create',
  productCategoryList: '/api/admin-service/product-category/list',
  productCategoryKeyValuePair: '/api/admin-service/product-category/key-value-list',
  productCategoryKeyValuePair: '/api/admin-service/product-category/get-all-key-value-list',
  changeProductCategoryStatus: '/api/admin-service/product-category/change/status',


  addBusinessMerchant: '/api/admin-service/get-all-merchants',
  businessMerchantList: '/api/admin-service/get-all-merchants',
  businessMerchantDetails: '/api/admin-service/get-business-details-by-merchant-id',
  changeBusinessMerchantStatus: '/api/admin-service/approve-merchant',
  getAgentGuarantorDetails: '/api/admin-service/get-agent-guarantor-details',


  agentList: '/api/admin-service/agents/list',
  updateAgentStatus: '/api/admin-service/agents/update-status',

  agencyList: '/api/admin-service/agents/list',
  agencyDetails: '/api/admin-service/agents/get-details',
  updateAgencyStatus: '/api/admin-service/agents/update-status',
  changeAgencyStatus: '/api/admin-service/agents/change/status',

  ridersList: '/api/admin-service/riders/list',
  updateRidersStatus: '/api/admin-service/riders/update-status',

  affiliatesUserList: '/api/admin-service/affiliate/list',
  updateAffiliatesUserStatus: '/api/admin-service/affiliate/update-status',

  addInfluencerCategory: '/api/admin-service/influencer-category/add',
  influencerCategoryList: '/api/admin-service/influencer-category/list',
  changeInfluencerCategoryStatus: '/api/admin-service/influencer-category/change/status',

  addLanguage: '/api/admin-service/language/add',
  languageList: '/api/admin-service/language/language-list',
  languageListKeyValuePair: '/api/admin-service/language/language-key-value',
  changeLanguageStatus: '/api/admin-service/language/change/status',
  deleteLanguage: '/api/admin-service/language/delete/by/id',

  addNetworkServiceProvider: '/api/admin-service/network-provider/add',
  networkServiceProviderList: '/api/admin-service/network-provider/list',
  changeNetworkServiceProviderStatus: '/api/admin-service/network-provider/status',
  networkProviderKeyValueByCountry: '/api/admin-service/network-provider/key-value',
  newsCategoryList: '/api/admin-service/newsFeedCategory/list',
  addNewsCategory: '/api/admin-service/newsFeedCategory/add-edit',

  newsFeedList: '/api/admin-service/newsFeed/list?pageNumber=0&pageSize=2&searchText=""&shortingField=createdAt&asc=true&status=""&active=true&categoryId=""&countryId=""',
  addBanner: '/api/admin-service/banners/add',
  bannerList: '/api/admin-service/banners/banner-list',
  changeBannerStatus: '/api/admin-service/banners/change/status',

  addVehicleCategory: '/api/admin-service/vehicle-category/add',
  vehicleCategoryList: '/api/admin-service/vehicle-category/list',
  changeVehicleCategoryStatus: '/api/admin-service/vehicle-category/change/status',

  addUpdateServiceProviderPlans: '/api/admin-service/service-provider-plan/add',
  getServiceProviderPlans: '/api/admin-service/service-provider-plan/get-details',

  addLiveReelCategory: '/api/admin-service/live-reel-category/add',
  liveReelCategoryList: '/api/admin-service/live-reel-category/list',
  changeLiveReelCategoryStatus: '/api/admin-service/live-reel-category/change/status',
  liveReelCategoryKeyValuePair: '/api/admin-service/live-reel-category/list-for-user',

  addRadio: '/api/admin-service/radio/add',
  radioList: '/api/admin-service/radio/list',
  changeRadioStatus: '/api/admin-service/radio/active-inactive',
  changeRadioAdminApprovedStatus: '/api/admin-service/radio/approve-disapprove',

  addSticker: '/api/admin-service/stickers/add',
  stickerList: '/api/admin-service/stickers/list',
  meisheAssetsList: '/api/admin-service/meishe/list-admin',
  changeMeisheAssetsStatus: '/api/admin-service/meishe/status',
  deleteSticker: '/api/admin-service/stickers/delete/by/id',

  addFaq: '/api/admin-service/faqs/add',
  faqList: '/api/admin-service/faqs/faq-list',
  changeFaqStatus: '/api/admin-service/faqs/change/status',
  updateSequence: '/api/admin-service/faqs/update-seq',
  faqById: '/api/admin-service/faqs/get/by',

  uploadImage: '/api/admin-service/blogs/upload-image',
  addBlog: '/api/admin-service/blogs/add',
  blogList: '/api/admin-service/blogs/blog-list',
  changeBlogStatus: '/api/admin-service/blogs/change/status',

  addAds: '/api/admin-service/ads/add',
  adsList: '/api/admin-service/ads/ad-list',
  changeAdsStatus: '/api/admin-service/ads/change/status',
  changeInfluencerAdsStatus: '/api/admin-service/ads/influencer-change/status',
  deleteAds: '/api/admin-service/ads/delete/by/id',

  globalAdsList: '/api/admin-service/globalAds/admin-ads-list',

  influencerRequestList: '/api/admin-service/users/influencer/request-list',
  influencerRequestAcceptOrReject: '/api/admin-service/users/influencer/accept',

  userSearchDropdownList: '/api/admin-service/users/user-list-search',
  sendBatchPushNotification:
    '/api/admin-service/users/send-batch-push-notification-user',

  updateStaticContent: '/api/admin-service/contents/add',
  staticContentList: '/api/admin-service/contents/static-list',

  setGlobalSetting: '/api/admin-service/settings/add',
  getGlobalSetting: '/api/admin-service/settings/get-details',

  getTypeOfAdvertisement: '/api/admin-service/globalAds/typeOfAdvertisement',

  updateEmail: '/api/admin-service/email-template/add',
  emailList: '/api/admin-service/email-template/template-list',
  testAddUser: '/api/user-service/users/signup-complete',

  withdrawTransactioNList: '/api/admin-service/withdraw/transaction-list',
  totalWithdrawCommission:
    '/api/admin-service/withdraw/get-total-withdraw-commission',
  enableDisableMfaPayStack:
    '/api/admin-service/bank/enable-disable-otp-on-transaction',
  verifyMfaPayStackOtp: '/api/admin-service/bank/verify-disable-otp',
  paystackAvailableBalance: '/api/admin-service/bank/balance',
  approveDeclineTransaction: '/api/admin-service/withdraw/approve-denied',
  finalApproveTransactionVerification:
    '/api/admin-service/bank/final-approve-transaction',
  topUpUserWallet: '/api/admin-service/beads/top-up',

  purchaseBeadsList: '/api/admin-service/beads/purchase-history',
  liveManagerList: '/api/admin-service/live/list',
  // beadsTransactionHistory: '/api/admin-service/beads/transaction-history',
  beadsTransactionHistory: '/api/admin-service/transaction/history',
  amountTransactionHistory: '/api/admin-service/transaction/amount-history',
  addMeisheAssets: '/api/admin-service/meishe/add',
  updateMeisheAssets: '/api/admin-service/meishe/update',

  addPromoVideo: '/api/admin-service/promo/upload',
  listPromoVideo: '/api/admin-service/promo/list',
  changePromoVideoStatus: '/api/admin-service/promo/change/status',

  ayrshareProfileList: '/api/admin-service/ayrshare-profile/list',
  ayrsharePostList: 'api/admin-service/ayrshare-profile',

  GET_PARENT_TAX_TEMPLATES: '/api/admin-service/tax-template/get-parent-tax-templates',
  addTaxTemplate: '/api/admin-service/tax-template/add',
  updateTaxTemplate: '/api/admin-service/tax-template/update',
  taxTemplatesList: '/api/admin-service/tax-template/list',

  productList: '/api/admin-service/product/search-product-admin',
  changeProductStatus: '/api/admin-service/product/change-status',
  approveRejectProduct: '/api/admin-service/product/approve-reject-product',
  updateProduct: '/api/admin-service/product/update',
  updateProductCategory: '/api/admin-service/product-category/update-product-category',

  serviceList: '/api/admin-service/service/search-services-admin',
  changeServiceStatus: '/api/admin-service/service/change-status',
  approveRejectService: '/api/admin-service/service/approve-reject',
  productOrServiceCategory: '/api/admin-service/service/category-list',

  // Discount Vouchers APIs
  discountVouchersList: '/api/admin-service/product/discount-vouchers/get-list',
  addEditDiscountVoucher: '/api/admin-service/product/discount-vouchers/create',
  deleteDiscountVoucher: '/api/admin-service/product/discount-vouchers/delete',
  toggleDiscountVoucherStatus: '/api/admin-service/product/discount-vouchers/active-inactive',

  // Discount Voucher Unit Configuration APIs
  discountVoucherUnitConfigList: '/api/admin-service/country/discount-configuration/list',
  discountVoucherUnitConfig: '/api/admin-service/country/discount-configuration/add',
  discountVoucherUnitConfigStatusChange: '/api/admin-service/country/discount-configuration/change/status',

  // Product Discount APIs
  productDiscountList: '/api/admin-service/product/get-discount-list',

  // Viewer Subscription APIs
  viewerSubscriptionList: '/api/admin-service/viewer-subscription/list',
  addViewerSubscription: '/api/admin-service/viewer-subscription/add',
  networkProviderDetails: '/api/admin-service/network-provider/get-details-by-list', // For getting network provider details by ID list
  countryDetails: '/api/admin-service/country/get-details-by-list', // For getting country details by ID list

  // Merchant Subscription Plans APIs
  merchantSubscriptionPlansList: '/api/admin-service/merchant-subscription/list',
  merchantSubscriptionPlanDetails: '/api/admin-service/merchant-subscription/details',
  addMerchantSubscriptionPlan: '/api/admin-service/merchant-subscription/add',
  changeMerchantSubscriptionPlanStatus: '/api/admin-service/merchant-subscription/change-status',
  merchantSubscriptionCategories: '/api/admin-service/merchant-subscription/get-category-key-value',
  merchantSubscriptionPartners: '/api/admin-service/merchant-subscription/get-partners-key-value',
}
export default urls